package com.milta.feature.route.domain.entity

/** MIL-45 — mirrors backend `GeocodeStatus`. [Degraded] means the geocoding service itself was
 * unreachable (retry later), distinct from [Failed] (address genuinely not found). Both render the
 * same "not located" warning to the Gestionnaire — the distinction only matters for retry logic. */
enum class GeocodeStatus {
    Pending,
    Geocoded,
    Failed,
    Degraded,
}
